import { CommitmentSourcesService_commitmentSourcesServiceGetCommitmentApplications } from '@festina/life-general-types/life/hooks/CommitmentSourcesApplicationsService_commitmentSourcesServiceGetCommitmentApplications'

export const useFetchCommitmentSourcesApplications =
  CommitmentSourcesService_commitmentSourcesServiceGetCommitmentApplications.useSuspenseQuery
